"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
exports.palette = {
    action: {
        outline: 'rgba(0, 0, 0, 0.54)',
    },
    primary: {
        '50': 'rgb(239, 247, 249)',
        '100': '#49cde1',
        '200': '#2ebed4',
        '300': '#2c9daf',
        '400': '#006877',
        '500': '#246c77',
        '600': '#225961',
        '700': '#1f474d',
        '800': '#1b3539',
        '900': '#152528',
    },
    secondary: {
        '50': '#14c11a10f',
        '100': '#12911010a',
        '200': '#109103102',
        '300': '#ecf6f8',
        '400': '#CDE7ED',
        '500': '#c0dee4',
        '600': '#b2d3da',
        '700': '#a7c7ce',
        '800': '#9cbac1',
        '900': '#93adb3',
    },
    error: {
        '50': '#FAEAEA',
        '100': '#e48273',
        '200': '#d86958',
        '300': '#c9523f',
        '400': '#952A1F',
        '500': '#974032',
        '600': '#803c32',
        '700': '#6a3730',
        '800': '#40120D',
        '900': '#432b27',
    },
    info: {
        '50': 'rgb(244, 247, 253)',
        '100': '#49bfff',
        '200': '#22b2ff',
        '300': '#02a1f6',
        '400': '#0288d1',
        '500': '#0776b2',
        '600': '#0b6697',
        '700': '#0e567d',
        '800': '#0f4664',
        '900': '#0f374d',
    },
    success: {
        '50': '#C4DFD7',
        '100': '#0def2b',
        '200': '#11c329',
        '300': '#139925',
        '400': '#00A580',
        '500': '#0f5e1a',
        '600': '#0f4716',
        '700': '#0c3211',
        '800': '#00664F',
        '900': '#040b05',
    },
    warning: {
        '50': 'rgb(253, 240, 204)',
        '100': '#ffdb82',
        '200': '#ffd05a',
        '300': '#fcc435',
        '400': '#f6b80f',
        '500': '#e7a80b',
        '600': '#ca9510',
        '700': '#ae8314',
        '800': 'rgb(174, 130, 7)',
        '900': '#7b5f18',
    },
    danger: {
        '50': '#FAEAEA',
        '100': '#e48273',
        '200': '#d86958',
        '300': '#c9523f',
        '400': '#952A1F',
        '500': '#974032',
        '600': '#803c32',
        '700': '#6a3730',
        '800': '#40120D',
        '900': '#432b27',
    },
    text: {
        '400': 'rgba(0, 0, 0, 0.87)',
        '200': '#3F484A',
        '100': 'rgba(0, 0, 0, 0.38)',
    },
};
